import * as React from "react";
import { forwardRef } from "react";
const SvgCloseBold = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m10.263 8 5.272-5.272a1.61 1.61 0 0 0 0-2.26A1.6 1.6 0 0 0 14.403 0a1.6 1.6 0 0 0-1.131.469L8 5.74 2.728.47A1.6 1.6 0 0 0 1.597 0 1.6 1.6 0 0 0 .465.469a1.607 1.607 0 0 0 0 2.26L5.737 8 .465 13.272a1.607 1.607 0 0 0 0 2.26A1.6 1.6 0 0 0 1.597 16a1.6 1.6 0 0 0 1.131-.469L8 10.26l5.272 5.271a1.6 1.6 0 0 0 1.131.469 1.6 1.6 0 0 0 1.132-.469 1.61 1.61 0 0 0 0-2.26z" }));
const ForwardRef = forwardRef(SvgCloseBold);
export { ForwardRef as ReactComponent };
